<template>
    <div v-if="contrato">
        <form class="form-horizontal" >
            <div class="form-group">
                <div class="col-sm-12">
                    <label class="control-label">NOME DO CLIENTE</label>
                    <input disabled type="text" v-model="contrato.cliente.nome" class="form-control" >
                </div>
            </div>
            <list-logs :id="contrato._id"></list-logs>
        </form>
    </div>
</template>
<script>
import ListLogs from "../../../components/contratos/ListLogs.vue";
import contratoMixin from "../../mixins/contrato";
export default {
    components: {
        ListLogs
    },
    mixins: [contratoMixin]
};
</script>
